import { createReducer } from '@reduxjs/toolkit'
import { PortfolioLibraryCount, PortfolioLibraryItem, PortfolioStatus } from '../../models/Portfolio';
import { addFundToPortfolio, deletePortfolio, loadPortfolioCount, loadPortfolioLibrary, setPage, setViewType, updaterCounter } from '../actions/portfolioLibrary';

export interface PortfolioLibraryReducer {
    viewType: PortfolioStatus;
    protfolios: PortfolioLibraryItem[] | undefined;
    portfoliosCount: PortfolioLibraryCount[] | undefined;
    loading: boolean;
    page: number;
}

const initialState: PortfolioLibraryReducer = {
    viewType : PortfolioStatus.Live,
    protfolios: undefined,
    portfoliosCount: undefined,
    loading: false,
    page: 0
}

const portfolioLibraryReducer = createReducer<PortfolioLibraryReducer>(initialState, (builder) => {
    builder.addCase(setPage, (state, action) => {
        state.page = action.payload;
    })
    builder.addCase(setViewType, (state, action) => {
        state.viewType = action.payload;
        state.page = 0;
    });
    builder.addCase(loadPortfolioLibrary.pending, (state) => {
        state.protfolios = undefined;
        state.loading = true;
    });
    builder.addCase(loadPortfolioLibrary.fulfilled, (state, action) => {
        state.protfolios = action.payload;
        state.loading = false;
    });
    builder.addCase(loadPortfolioCount.pending, (state) => {
        state.portfoliosCount = undefined;
        state.loading = true;
    });
    builder.addCase(loadPortfolioCount.fulfilled, (state, action) => {
        state.portfoliosCount = action.payload;
        state.loading = false;
    });
    builder.addCase(deletePortfolio.pending, (state) => {
        state.loading = true;
    });
    builder.addCase(deletePortfolio.fulfilled, (state, action) => {
        state.loading = false;
        const portfolios = [...state.protfolios as PortfolioLibraryItem[]];
        for(let i = 0; i < portfolios.length; i++){
            if (portfolios[i].id === action.payload){
                portfolios.splice(i, 1);
                (state.portfoliosCount as PortfolioLibraryCount[])[0].count--;
                state.protfolios = portfolios;
                return;
            }
        }
    });
    builder.addCase(addFundToPortfolio.pending, (state) => {
        state.loading = true;
    });
    builder.addCase(addFundToPortfolio.fulfilled, (state) => {
        state.loading = false;
    });
    builder.addCase(updaterCounter, (state, action) => {
        if (state.portfoliosCount){
            const match = state.portfoliosCount.find(s => s.status === action.payload.status);
            if (match){
                match.count += action.payload.change;
            }
        }
    });
});

export default portfolioLibraryReducer;
